module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/bulk-upload/bulk-upload.component.css
// module id = ./src/app/ultilities/bulk-upload/bulk-upload.component.css
// module chunks = main